"use strict";
exports.__esModule = true;
//# sourceMappingURL=bookmark.type.js.map